import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
      <div className="text-center mb-8">
        <span className="inline-flex w-12 h-12 rounded-sm bg-gold items-center justify-center font-display font-black text-navy-950">10X</span>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-100 mt-5">SIGN IN TO THE NETWORK</h1>
        <p className="text-sm text-slate-500 mt-2">Access your business intelligence dashboard.</p>
      </div>
      <form onSubmit={submit} className="card-surface p-7 space-y-5" data-testid="login-form">
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Business Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com"
            data-testid="login-email-input" className="input-dark" />
        </div>
        <div>
          <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-2">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
            data-testid="login-password-input" className="input-dark" />
        </div>
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <div className="flex justify-end -mt-2">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-[11px] font-mono uppercase tracking-widest text-gold/80 hover:text-gold transition-colors">Forgot Password?</Link>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit-btn" className="btn-gold w-full disabled:opacity-60">
          {loading ? "SIGNING IN…" : "SIGN IN"}
        </button>
        <p className="text-center text-xs text-slate-500">New to the network? <Link to="/join" className="text-gold font-semibold" data-testid="login-join-link">Create your Business ID</Link></p>
        <p className="text-center text-[11px] font-mono text-slate-600 pt-2 border-t border-slate-800">Demo access: demo@10xglobal.com</p>
      </form>
    </div>
  );
}
